export default __webpack_public_path__ + "static/media/image3tum.abd348a2.jpg";